import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';
import { FormularioComponent } from './components/formulario/formulario.component';
import { ResumenCitasComponent } from './components/resumen-citas/resumen-citas.component';
import { SectoresProductivosComponent } from './components/sectores-productivos/sectores-productivos.component';

import { EstandaresHomeComponent } from './components/estandares-home/estandares-home.component';
import { SectoresOrganizacionalesComponent } from './components/sectores-organizacionales/sectores-organizacionales.component';
import { RenacHomeComponent } from './components/renac-home/renac-home.component';
import { OrganismosHomeComponent } from './components/organismos-home/organismos-home.component';
import { EntidadesHomeComponent } from './components/entidades-home/entidades-home.component';
import { EntidadesDetalleComponent } from './components/entidades-home/entidades-detalle/entidades-detalle.component';
import { OrganismosDetalleComponent } from './components/organismos-home/organismos-detalle/organismos-detalle.component';
import { EntidadesEstandaresComponent } from './components/entidades-home/entidades-estandares/entidades-estandares.component';
import { OrganismosEstandaresComponent } from './components/organismos-home/organismos-estandares/organismos-estandares.component';
import { ComiteHomeComponent } from './components/comite-home/comite-home.component';
import { ComiteDetalleComponent } from './components/comite-home/comite-detalle/comite-detalle.component';
import { RenapHomeComponent } from './components/renap-home/renap-home.component';
const routes: Routes = [
  {path:'', pathMatch:'full', redirectTo:'/agendarCita'},
  {path:'agendarCita', component: FormularioComponent} , 
  {path:'citasResumen', component: ResumenCitasComponent},
  {path:'sectoresProductivos', component: SectoresProductivosComponent},
  {path:'renec', component: EstandaresHomeComponent},
  {path:'renac', component: RenacHomeComponent},
  {path:'renap', component: RenapHomeComponent},
  {path:'entidades', component: EntidadesHomeComponent}, 
  {path:'organismos', component: OrganismosHomeComponent}, 
  {path:'comite', component: ComiteHomeComponent}, 
  {path:'comite/:id', component: ComiteDetalleComponent}, 
  {path:'sectoresOrganizacionales', component: SectoresOrganizacionalesComponent},
  {path: 'detalleEntidad/:id', component: EntidadesDetalleComponent },
  {path: 'detalleOrganismo/:id', component: OrganismosDetalleComponent },
  {path: 'estandaresEntidad/:id', component: EntidadesEstandaresComponent },
  {path: 'estandaresOrganismos/:id', component: OrganismosEstandaresComponent },
  {path:'renap/certificados/:curp', component: RenapHomeComponent},
  {path:'**', redirectTo:'/agendarCita', pathMatch: "full"  },
];

@NgModule({
  imports: [BrowserModule,RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
